import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import { getDate } from "../../common/DisplayDate";
import getPersonName from "../../common/Name";
import getSsn from "../../common/Ssn";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class FederalFirearms extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const records = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].firearmExplosives[0].firearmExplosive"
      );
      if (records !== undefined) {
        _.forEach(records, (record, index) => {
          rows.push(
            <Table.Row key={`row_fire_exp_name_${index}`}>
              <Table.Cell width={3}> Name: </Table.Cell>
              <Table.Cell width={7}>
                {getPersonName(
                  _.get(record, "name[0].first[0]._", ""),
                  _.get(record, "name[0].middle[0]._", ""),
                  _.get(record, "name[0].last[0]._", ""),
                  props
                )}
              </Table.Cell>
              <Table.Cell width={2}>IRS Region:</Table.Cell>
              <Table.Cell width={3}>
                {_.get(record, "IRSRegion[0]._", "")}
              </Table.Cell>
            </Table.Row>
          );

          rows.push(
            <Table.Row key={`row_fire_exp_trade_${index}`}>
              <Table.Cell width={3}> Trade Name: </Table.Cell>
              <Table.Cell width={8}>
                {_.get(record, "tradeName[0]._", "")}
              </Table.Cell>
              <Table.Cell width={2}> Type: </Table.Cell>
              <Table.Cell width={3}>
                {_.get(record, "licenseType[0]._", "")}
              </Table.Cell>
            </Table.Row>
          );

          rows.push(
            <Table.Row key={`row_fire_exp_mailing_address_${index}`}>
              <Table.Cell width={3}> Mailing Address: </Table.Cell>
              <Table.Cell width={8}>
                <Address
                  addressNode={_.get(record, "mailingAddress[0]")}
                  {...this.props}
                />
              </Table.Cell>
              <Table.Cell width={2}>License Number:</Table.Cell>
              <Table.Cell width={3}>
                {_.get(record, "licenseNumber[0]._", "")}
              </Table.Cell>
            </Table.Row>
          );

          rows.push(
            <Table.Row key={`row_fire_exp_premise_address_${index}`}>
              <Table.Cell width={3}> Premise Address: </Table.Cell>
              <Table.Cell width={8}>
                <Address
                  addressNode={_.get(record, "premiseAddress[0]")}
                  {...this.props}
                />
              </Table.Cell>
              <Table.Cell width={2}>Issue State:</Table.Cell>
              <Table.Cell width={3}>
                {_.get(record, "licenseIssueState[0]._", "")}
              </Table.Cell>
            </Table.Row>
          );

          rows.push(
            <Table.Row key={`row_fire_exp_dob_${index}`}>
              <Table.Cell width={3}> Phone: </Table.Cell>
              <Table.Cell width={8}>
                {_.get(record, "businessPhone[0]._", "")}
              </Table.Cell>
              <Table.Cell width={2}>Expiration Date:</Table.Cell>
              <Table.Cell width={3}>
                {getDate(_.get(record, "licenseExpireDate[0]"))}
              </Table.Cell>
            </Table.Row>
          );

          rows.push(
            <Table.Row key={`row_fire_exp_ssn_${index}`}>
              <Table.Cell width={3}> SSN: </Table.Cell>
              <Table.Cell width={8}>
                {getSsn(_.get(record, "SSN[0]._"), this.props)}
              </Table.Cell>
              <Table.Cell width={2}>County:</Table.Cell>
              <Table.Cell width={3}>
                {_.get(record, "countyName[0]._", "")}
              </Table.Cell>
            </Table.Row>
          );
        });
        recCount = rows.length;
      } else {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Federal Firearms & Explosives"}
        rows={this.state.rows}
      />
    );
  }
}

export default FederalFirearms;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/FederalFirearms.js